export default function base64ToArrayBuffer(b64Encoded) {
  const binaryString = window.atob(b64Encoded);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i += 1) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
}
